/**
 * Service API payment-links — version donoor.org
 *
 * Couche 1 — Transport (ADR-001). Tracking d'analytics fire-and-forget
 * pour les pages `/pay/[slug]` et le widget embarquable : scan (QR / NFC)
 * vs click.
 *
 * La page elle-même utilise `useFetch` SSR pour le payload de paiement
 * (SEO-critique). Ce service ne couvre que l'incrément analytics CSR
 * post-hydration.
 *
 * ⚠️ `$fetch` nu, SANS corps ni en-tête (et non `apiCall`) : c'est la requête
 * historique des tunnels de don (`DonateCheckoutApp` / `DonateEmbedApp`). Un
 * corps JSON ajouterait un `Content-Type: application/json`, donc un preflight
 * CORS en plus — y compris dans l'iframe d'un site hôte. La base d'API est
 * passée par l'appelant (résolue au setup), comme pour `rechercheApi`.
 */

export type PaymentLinkHitKind = "scan" | "click";

export const paymentLinksApi = {
  /**
   * Incrémente le compteur de scans/clicks d'un payment-link.
   * Fire-and-forget — ne rejette JAMAIS (analytics best-effort) : l'appelant
   * peut l'appeler sans `await` ni `catch`.
   */
  async trackHit(
    baseUrl: string,
    slug: string,
    kind: PaymentLinkHitKind,
  ): Promise<void> {
    try {
      await $fetch(`${baseUrl}/api/public/payment-link/${slug}/${kind}`, {
        method: "POST",
      });
    } catch {
      // Non-bloquant : analytics best-effort
    }
  },
};
